import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Utilities } from '../../utils/utilities';
import { PostPayloadInterface } from '../../models/post-payload.interface';

export abstract class SuperRepoRepository {
  private _serviceUrl: string;
  protected httpClient: HttpClient;

  protected constructor() {
    this._serviceUrl = Utilities.getServiceUrl();
  }

  public get(path: string, options?: any): Observable<any> {
    return this.httpClient.get(this._serviceUrl + path, options).pipe(catchError(Utilities.handleError));
  }

  public post(path: string, body: PostPayloadInterface, options?: any): Observable<any> {
    return this.httpClient.post(this._serviceUrl + path, body, options).pipe(catchError(Utilities.handleError));
  }

  public postFile(path: string, body: FormData, options?: any): Observable<any> {
    return this.httpClient.post(this._serviceUrl + path, body, options).pipe(catchError(Utilities.handleError));
  }

  public put(path: string, body: PostPayloadInterface, options?: any): Observable<any> {
    return this.httpClient.put(this._serviceUrl + path, body, options).pipe(catchError(Utilities.handleError));
  }

  public patch(path: string, body?: PostPayloadInterface, options?: any): Observable<any> {
    return this.httpClient.patch(this._serviceUrl + path, body, options).pipe(catchError(Utilities.handleError));
  }

  public patchFile(path: string, body: FormData, options?: any): Observable<any> {
    return this.httpClient.patch(this._serviceUrl + path, body, options).pipe(catchError(Utilities.handleError));
  }

  public delete(path: string, options?: any): Observable<any> {
    return this.httpClient.delete(this._serviceUrl + path, options).pipe(catchError(Utilities.handleError));
  }

  set serviceUrl(value: string) {
    this._serviceUrl = value;
  }

}
